import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { SignupService } from '../../service/index';
import {
  CommonFunctionsService,
  UserService,
  SeoService,
  ValidationService,
  NgxToasterService,
} from '../../../../_services/index';

@Component({
  selector: 'expediusa-shared-element-change-password',
  templateUrl: './change_password.component.html',
  styleUrls: ['./change_password.component.css'],
  providers: [CommonFunctionsService, UserService, SeoService, SignupService],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  /**This is used to prevent memory leaks **/
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  /**This is used to prevent memory leaks **/

  env = environment;
  changePasswordForm: FormGroup;
  changePasswordFormError: any = {};
  isLoading: boolean = false;
  isBrowser: boolean = false;

  // Declare Constructor
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    private toasterNotification: NgxToasterService,
    private signupService: SignupService,
    public userService: UserService,
    public commonFunctionsService: CommonFunctionsService
  ) {
    //initialization change password form
    this.changePasswordForm = this.formBuilder.group({});
  }

  // Declare initialization
  ngOnInit(): void {
    /**This function is used to create change password form */
    this.createChangePasswordForm();
    /**This function is used to create change password form*/

    this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
      if (isBrowser) {
        let that = this;
        that.isBrowser = true;
      }
    });
  }

  /** this function is used to create change password form */
  public createChangePasswordForm(): void {
    this.changePasswordForm = this.formBuilder.group({
      user_slug: [''],
      old_password: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]],
    });
  }
  /** this function is used to create change password form */

  /** this function is used to submit change password form on enter*/
  public changePasswordFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.changePassword();
    }
  }
  /** this function is used to submit change password form on enter*/

  /** this function is used to submit change password form on enter*/
  public changePassword() {
    this.isLoading = true;
    let slug = this.userService.getCurrentUser().slug;
    if (this.changePasswordForm.valid && slug != undefined && slug != null) {
      this.changePasswordForm.patchValue({
        user_slug: slug,
      });
      let formData = { ...this.changePasswordForm.value };
      this.signupService
        .changePassword(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            localStorage.setItem('user_id', response.user_id);
            this.isLoading = false;
            this.toasterNotification.showSuccess(response.message);
            this.changePasswordForm.reset();
            this.changePasswordFormError = {};
          } else {
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.changePasswordFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
      ValidationService.validateAllFormFields(this.changePasswordForm);
    }
  }
  /** this function is used to submit change password form on enter*/

  /**This function are used for destroy the data**/
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
  }
  /**This function are used for destroy the data**/
}
